import { apiGet, apiPut } from './client';

export interface OrderPreferences {
  supplierIds: number[];
  cities: string[];
  locations: string[];
}

export const orderPreferencesApi = {
  get(): Promise<OrderPreferences> {
    return apiGet<OrderPreferences>('/order-preferences');
  },
  update(prefs: OrderPreferences): Promise<OrderPreferences> {
    return apiPut<OrderPreferences, OrderPreferences>('/order-preferences', prefs);
  },
};
